
<p *ngFor="let data of gridRowHiddenDetails" >
    <small><b>{{data.header}}:</b> {{data.value}}</small>
</p>
